module.exports = __webpack_public_path__ + "static/media/gamepad-alt.3f093f96.svg";